import React, { useState,useContext,useEffect } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import AuthContext from '../SecurityConfig/AuthContext';
import { endpoint } from '../../resource/Constant';
const SchoolRegistration = () => {
  const [schoolName, setSchoolName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
   const { setLoginDetails, loginDetails } = useContext(AuthContext);
 useEffect(() => {
    if (loginDetails.isAuthenticated) navigate('/lessonplanner/dashboard');
  }, []);
  const handleRegistration = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    if (!schoolName.trim()) {
      setError('School Name is required');
      setLoading(false);
      return;
    }
    if (!email.trim()) {
      setError('Email is required');
      setLoading(false);
      return;
    }
    if (!password.trim()) {
      setError('Password is required');
      setLoading(false);
      return;
    }

    const requestBody = {
      school_name: schoolName,
      email: email,
      password: password,
    };

    try {
      const response = await axios.post(`${endpoint}/signup`, requestBody);
      setMessage(response?.data?.message);
      setLoading(false);
      navigate('/lessonplanner/signin');
    } catch (error) {
      setError(error?.response?.data?.message || 'Registration failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <>
    <Header />
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f4f6f8',
        flexDirection: 'column',
        position: 'fixed',
        width: '100%',
      }}
    >
      <Paper sx={{ width: '100%', maxWidth: '470px', borderRadius: '12px', backgroundColor: 'white', boxShadow: 3, padding: 4 }}>
        <Typography variant="h6" sx={{ mb: 1, textAlign: 'center', fontWeight: 'bold', color: '#1976d2', fontSize: '[1.5rem]' }}>
          School Registration
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: '#64748b' }}>
          Create an account for your school
        </Typography>

        <form onSubmit={handleRegistration}>
          <TextField
            type="text"
            label="School Name"
            fullWidth
            value={schoolName}
            onChange={(e) => setSchoolName(e.target.value)}
            sx={{ mb: 2, borderRadius: '12px' }}
            required
          />
          <TextField
            type="email"
            label="Email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2, borderRadius: '12px' }}
            required
          />
          <TextField
            type="password"
            label="Password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 3, borderRadius: '12px' }}
            required
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ py: 1.5, fontSize: '16px', borderRadius: '8px', textTransform: 'none', mt: 1 }}
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                Registering...
              </>
            ) : (
              'Register'
            )}
          </Button>
        </form>

        {message && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            Already have an account?{' '}
            <Link to="/lessonplanner/signin" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500 }}>
              Sign In
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Box>
    </>
  );
};

export default SchoolRegistration;
